import React, { useState, useEffect } from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Questionnaire from "../../components/Questionnaire/Questionnaire";
import { motion, AnimatePresence } from "framer-motion";
import QuestionnaireCompletion from "../../components/Modals/QuestionnaireCompletion";
import { useUser } from "../../providers/UserProvider";
import { useNavigate } from "react-router-dom";

const LoggedinHome = () => {
  const { hasTreeData } = useUser();
  const navigate = useNavigate();
  const [currStep, setCurrStep] = useState(1);
  const [showCompletionModal, setShowCompletionModal] = useState(false);
  const buttonText = currStep === 7 ? "Complete & Submit" : "Next";

  const handleNextQues = () => {
    if (currStep < 7) {
      setCurrStep(currStep + 1);
    } else if (currStep === 7) {
      setShowCompletionModal(true);
    }
  };

  const handlePrevQues = () => {
    if (currStep > 0) {
      setCurrStep(currStep - 1);
    }
  };
  useEffect(() => {
    if (hasTreeData) {
      navigate("/organization-tree");
    }
  }, [hasTreeData]);
  return (
    <div className="">
      <Header />

      {/* questionnaire */}
      <Questionnaire currStep={currStep} />

      {/* <div className={`flex mx-11 mt-6 mb-96 ${currStep === 1 ? 'justify-end' : 'justify-between'}`}>
        <AnimatePresence mode='popLayout'>
            {currStep > 1 && (<motion.button className="border border-[#D9D9D9] flex gap-3 justify-center items-center py-[0.825rem] rounded-[10px] font-inter font-medium px-5 transition-opacity duration-[5000ms] ease-in-out"
                onClick={handlePrevQues}
                initial={{opacity:0}}
                animate={{opacity:1}}
                exit={{opacity:0}}
                transition={{duration:0.2}}
                >
                <svg width="17" height="8" viewBox="0 0 17 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.80775 0.192239L4.52125 0.899989L1.92125 3.49999H17V4.49999H1.92125L4.5155 7.09999L3.802 7.80774L0 3.99999L3.80775 0.192239Z" fill="#1C3F3A"/>
                </svg>
                Back
            </motion.button>)}
        </AnimatePresence>
            <motion.button
            layout
            className="bg-[#55C880] flex items-center justify-center text-white pl-5 pr-6 py-[0.825rem] rounded-[10px] overflow-hidden"
            onClick={handleNextQues}
            transition={{
                layout: { type: "spring", stiffness: 1000, damping: 80 }
            }}
            >
            <AnimatePresence mode="popLayout" initial={false}>
                <motion.span
                key={buttonText}
                initial={{ x: 250, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: -250, opacity: 0 }}
                transition={{ duration: 0.01 }}
                className="mr-3"
                >
                {buttonText}
                </motion.span>
            </AnimatePresence>
            <motion.svg
                width="17"
                height="8"
                viewBox="0 0 17 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                animate={{ x: buttonText === "Next" ? 0 : 5 }}
                transition={{ type: "spring", stiffness: 300, damping: 30 }}
            >
                <path d="M13.1923 7.80776L12.4788 7.10001L15.0788 4.50001H0V3.50001H15.0788L12.4845 0.900011L13.198 0.192261L17 4.00001L13.1923 7.80776Z" fill="white"/>
            </motion.svg>
            </motion.button>
        </div> */}
      <Footer />
      {showCompletionModal && (
        <QuestionnaireCompletion
          onClose={() => setShowCompletionModal(false)}
        />
      )}
    </div>
  );
};

export default LoggedinHome;
